export type NavMatch = 'exact' | 'prefix'

export function activeEntryIndex<T extends { to: string; match: NavMatch }>(
  pathname: string,
  entries: T[],
): number {
  for (let i = 0; i < entries.length; i++) {
    const e = entries[i]!
    const hit =
      e.match === 'exact' ? pathname === e.to : pathname === e.to || pathname.startsWith(e.to + '/')
    if (hit) return i
  }
  return -1
}
